import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { MarkdownContent } from "./styled";
import TypingIndicator from "../../TypingIndicator";
import DumontReplyBubble from "Components/AskDumont/DumontReplyBubble";

interface MessageDumontProps {
  text: string;
  isLoading?: boolean;
}

export default function MessageDumont({ text, isLoading }: MessageDumontProps) {
  return (
    <DumontReplyBubble>
      {isLoading ? (
        <TypingIndicator />
      ) : (
        <MarkdownContent>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
        </MarkdownContent>
      )}
    </DumontReplyBubble>
  );
}
